export default __webpack_public_path__ + "static/media/OldCoachHouseMap.6af9efc2.jpg";